import comp from "./AIPanelVoiceToText";
export default comp;
